import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useHistory } from 'react-router-dom';
import Login from '../Login';
import { getLiveCasinoGames, getSlotGameData } from '../../store/actions/casino.actions';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Game from '../Casino/Game';
import { toastr } from 'react-redux-toastr';
import NewLoading from '../../Components/Common/NewLoading';
import Util from '../../helper/Util';
import NavigateBeforeRoundedIcon from '@mui/icons-material/NavigateBeforeRounded';
import NavigateNextRoundedIcon from '@mui/icons-material/NavigateNextRounded';
import { Translate } from '../../localization';

const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 6,
    margin: 10,
    prevArrow: <button><NavigateBeforeRoundedIcon /></button>,
    nextArrow: <button><NavigateNextRoundedIcon /></button>,
    responsive: [
        {
            breakpoint: 1199,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
            },
        },
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
            },
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
            },
        },
    ],
};

const GameListCarousel = (props) => {
    const { search } = props;

    const history = useHistory();
    const dispatch = useDispatch();
    const [langCode, setLangCode] = useState(Translate.getLanguage())

    const [showLogin, setShowLogin] = useState(false);
    const [loading, setLoading] = useState(true);

    const userData = useSelector((state) => state.user.data);
    const casinoGames = useSelector((state) => state.casino.casinoGames);

    const callBackLoading = () => {
        setLoading(false);
    };

    useEffect(() => {
        let filters = {
            category: 'LIVECASINO',
            search,
            size: 15,
            page: 0,
            lang: Translate.getLanguage()
        };
        dispatch(getLiveCasinoGames(filters, true, callBackLoading));
    }, []);

    const isLoggedIn = () => {
        return userData !== null;
    };

    const playGame = (game, type) => {
        if (type == 'demo') {
            if (game?.demoSupport) {
                dispatch(getSlotGameData(game, type, history));
            } else {
                toastr.info('Please try another game this game dosn\'t support demo mode');
            }
        } else if (isLoggedIn()) {
            dispatch(getSlotGameData(game, type, history));
        } else {
            sessionStorage.setItem('gameData', JSON.stringify(game));
            setShowLogin(true);
        }
    };

    const hideLogin = () => {
        setShowLogin(false);
    };

    return (
        <>
            <section className="slider-section" key={search}>
                <div className="inner-heading-left d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        <img src={`/img/SVG/${search}.svg`} alt="favourites" />
                        <h4>{Translate.tabNames[search]}</h4>
                    </div>
                    <NavLink to={`/${langCode}/d/live-casino/categories/${search}`} key={search} className="viewAllBtn">
                        {Translate.viewall}
                    </NavLink>
                </div>
                {loading ?
                    <NewLoading customClass="casino-loader" />
                    : <div className="casino-game-parent" style={{ flexDirection: 'column' }}>
                        {casinoGames?.[search]?.length ? (
                            <Slider {...settings}>
                                {casinoGames?.[search].map((game) => {
                                    return <Game game={game} playGame={playGame} />;
                                })}
                                <li className="game-card-wrap game-card-more" key={search} id="casinoListDiv">
                                    <NavLink to={`/${langCode}/d/live-casino/categories/${search}`}>
                                        <div className="hover-parent">
                                            <img src="/images/game-more-img.png" className="casino-img" />
                                            <div className="play-btn">
                                                <span className="icon-wrap">
                                                    <i className="fas fa-plus-circle ico non-hover-ico"></i>
                                                    <i className="fas fa-plus-circle ico hover-ico"></i>
                                                </span>
                                            </div>
                                        </div>
                                        <div className="game-text-wrap d-flex justify-content-between align-items-center">
                                            <div className="game-text-left text-white">
                                                <h4>{Translate.discoverall}</h4>
                                                <p>{Translate.tabNames[search]}</p>
                                            </div>
                                        </div>
                                    </NavLink>
                                </li>
                            </Slider>
                        ) : (
                            <div className="col-12 text-center">
                                <p className="m-0">{Translate.nothingfound}</p>
                            </div>
                        )}
                    </div>}
            </section>
            {showLogin && <Login hideLogin={hideLogin} history={history}/>}
        </>
    );
};

export default GameListCarousel;
